type ImagesType = {
  src: string;
  alt: string;
}[];

export const CustomersArr: ImagesType = [
  {
    src: `${window.template_root}/v1/happyCustomers/1.jpg`,
    alt: "happy customer 1",
  },
  {
    src: `${window.template_root}/v1/happyCustomers/2.jpg`,
    alt: "happy customer 2",
  },
  {
    src: `${window.template_root}/v1/happyCustomers/3.jpg`,
    alt: "happy customer 3",
  },
  {
    src: `${window.template_root}/v1/happyCustomers/4.jpg`,
    alt: "happy customer 4",
  },
  {
    src: `${window.template_root}/v1/happyCustomers/5.jpg`,
    alt: "happy customer 5",
  },
  {
    src: `${window.template_root}/v1/happyCustomers/6.jpg`,
    alt: "happy customer 6",
  },
];
